import type { ChainInfo } from "@keplr-wallet/types";

export const nesaTestnet: ChainInfo = {
  bech32Config: {
    bech32PrefixAccAddr: "nesa",
    bech32PrefixAccPub: "nesapub",
    bech32PrefixConsAddr: "nesavalcons",
    bech32PrefixConsPub: "nesavalconspub",
    bech32PrefixValAddr: "nesavaloper",
    bech32PrefixValPub: "nesavaloperpub",
  },
  bip44: {
    coinType: 60,
  },
  chainId: "nesa_41444-1",
  chainName: "Nesa",
  chainSymbolImageUrl:
    "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/nesa/chain.png",
  currencies: [
    {
      coinDecimals: 18,
      coinDenom: "NES",
      coinGeckoId: "nesa",
      coinImageUrl:
        "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/nesa/nes.png",
      coinMinimalDenom: "anes",
    },
  ],
  feeCurrencies: [
    {
      coinDecimals: 18,
      coinDenom: "NES",
      coinGeckoId: "nesa",
      coinImageUrl:
        "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/nesa/nes.png",
      coinMinimalDenom: "anes",
      gasPriceStep: {
        average: 0.02,
        high: 0.1,
        low: 0.01,
      },
    },
  ],
  nodeProvider: {
    email: "dev@nesa.ai",
    name: "Nesa",
    website: "https://nesa.ai/",
  },
  rest: "https://lcd.nesa.ai",
  rpc: "https://rpc.nesa.ai",
  stakeCurrency: {
    coinDecimals: 18,
    coinDenom: "NES",
    coinGeckoId: "nesa",
    coinImageUrl:
      "https://raw.githubusercontent.com/chainapsis/keplr-chain-registry/main/images/nesa/nes.png",
    coinMinimalDenom: "anes",
    // features: ["cosmwasm"],
    // gasPriceStep: {},
  },
};
